import slugify from 'slugify';
import { MARKETPLACE_PRODUCTS_INDEX_DEFAULT_AU } from '../../constants';
export function transformFacetBrandHit(hit) {
  // I hate that we can't use kebabCase from lodash which generates IMO
  // more correct results, but we have to be consistent with commerce_service
  const slug = slugify(hit.value, {
    lower: true,
    strict: true
  }); // For backward compatibility with code that expects
  // all hits to have an objectID to use as keys etc.:

  const objectID = "facet-brand:".concat(slug);
  const title = hit.value; // Again for backward compatibility with how highlighting
  // from Algolia is normally structured:

  const _highlightResult = {
    title: {
      value: hit.highlighted
    }
  };
  return {
    title,
    slug,
    objectID,
    _highlightResult
  };
}
const MAX_BRAND_FACETS = 20;
const BRAND_FACET = 'variant.facets.brand-name';
export async function getFacetBrands(clients, queryText, analyticsTags) {
  return await clients.marketplace.initIndex(MARKETPLACE_PRODUCTS_INDEX_DEFAULT_AU).searchForFacetValues(BRAND_FACET, queryText, {
    maxFacetHits: MAX_BRAND_FACETS,
    sortFacetValuesBy: 'count',
    analyticsTags
  });
}